import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';

import routes from 'routes';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'assets/css/base.css';
import 'assets/css/layout.css';
import 'assets/css/style.css';

import { getPopups, getMetatagInfo } from 'apis/mainApi';
import { getCookie } from 'lib/cookies';


import ReactHelmet from 'components/MetaTag/ReactHelmet';
import PopUp from 'components/PopUp/PopUp';

function Public({ match }) {
  const [popupData, setPopupData] = useState([]);
  const [isShowPopup, setIsShowPopup] = useState([]);
  const [metatagInfo, setMetatagInfo] = useState({});

  const getPopup = async () => {
    setPopupData([]);
    await getPopups()
      .then((response) => {
        if (response.data.success) {
          setPopupData(response.data.result);
        }
      })
      .catch(() => {});
  };

  const getMetatag = async () => {
    setMetatagInfo([]);
    await getMetatagInfo()
      .then((response) => {
        if (response.data.success) {
          const obj = {};
          response.data.result.forEach(element => {
            obj[element.key] = element.value;
          });
          setMetatagInfo(obj);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    getMetatag();
    getPopup();
  }, []);

  const setUpPopup = () => {
    if (popupData && popupData.length > 0) {
      return popupData.map(p => {
        if (getCookie(`${process.env.REACT_APP_COOKIE_NAME}_p_${p.id}`)) {
          return null;
        }
        return (
          <PopUp
            popupId={p.id}
            width={p.width < 1 ? null : p.width}
            height={p.height < 1 ? null : p.height}
            showPopUp={isShowPopup}
            setShowPopUp={setIsShowPopup}
            time={p.disable_hours}
            content={p.content}
            link={p.link}
          />
        );
      });
    } else {
      return null;
    }
  };

  return (
    <>
      <ReactHelmet />
      <Switch>
        {routes.map((route, idx) => {
          if (route.layout === '/') {
            return (
              <Route
                key={idx}
                exact
                strict
                path={`${match.url}` + route.path}
                component={route.component}
              />
            );
          }
          return null;
        })}
      </Switch>
      {setUpPopup()}
    </>
  );
}

export default Public;
